import styled from 'styled-components';
import { colors, s16, s8 } from '@ardoq/design-tokens';
import { header3, header4 } from '@ardoq/typography';
import { FlexBox } from '@ardoq/layout';
import { Field, LABEL_SELECTOR } from '@ardoq/forms';

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${s8};
  padding: ${s16};
  border-bottom: 1px solid ${colors.grey200};
  ${header3}
`;

export const SectionsContainer = styled.div`
  flex: 1;
  overflow: auto;
`;

export const InputsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${s16};
  padding: ${s16};
`;

export const PanelFooter = styled(FlexBox).attrs({
  gap: 'small',
  align: 'center',
})`
  border-top: 1px solid ${colors.grey200};
`;

export const StyledField = styled(Field)`
  ${LABEL_SELECTOR} {
    ${header4};
  }
`;
